function NewsGridSlider(el) {
    this.el = el;
    this.gridEl = this.el.querySelector('.jsGrid');
    this.btnWrapper = this.el.querySelector('.jsBtnWrapper');

    this.init();
    this.setBtnVisibility();
}

NewsGridSlider.prototype.init = function () {
    window.addEventListener('resize', () => this.setBtnVisibility());

    this.flickity = new Flickity(this.gridEl, {
        pageDots: false,
        prevNextButtons: false,
        cellAlign: 'left',
        contain: true,
        groupCells: true,
        on: {
            change: () => this.setBtnVisibility()
        }
    });

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('prev')) this.flickity.previous();
        else if (e.target.classList.contains('next')) this.flickity.next();
    });

    // Prevent clicking links while dragging the slider
    this.flickity.on('dragStart', () => this.flickity.slider.style.pointerEvents = 'none');
    this.flickity.on('dragEnd', () => this.flickity.slider.style.pointerEvents = 'auto');
}

NewsGridSlider.prototype.setBtnVisibility = function() {
    // Show or hide all buttons
    let show = true;

    if (window.innerWidth < 650) show = this.flickity.cells.length > 1;
    else if (window.innerWidth < 1000) show = this.flickity.cells.length > 2;
    else show = this.flickity.cells.length > 3;

    this.btnWrapper.style.display = !show ? 'none' : '';

    // Show or hide individual buttons
    const current = this.flickity.selectedIndex;
    const total = this.flickity.slides.length;

    this.el.querySelector('.prev').disabled = current === 0;
    this.el.querySelector('.next').disabled = current >= total - 1;
};